module.exports = __webpack_public_path__ + "img/tp1.a5ba5dfb.png";